module.exports = __webpack_public_path__ + "img/clock.be5030ca.webp";